import * as Actions from "../../actions/app"

const initialState = {
  loading_profit_by_products: false,
  profit_by_products: [],
  total_profit_by_products: 0,

  loading_profit_by_sales: false,
  profit_by_sales: [],
  total_profit_by_sales: 0
}

const profitReportReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_PROFIT_BY_PRODUCTS: {
      return {
        ...state,
        loading_profit_by_products: action.payload.loading,
        profit_by_products: action.payload.items ?? state.profit_by_products,
        total_profit_by_products: action.payload.total ?? state.total_profit_by_products
      }
    }

    case Actions.GET_PROFIT_BY_SALES: {
      return {
        ...state,
        loading_profit_by_sales: action.payload.loading,
        profit_by_sales: action.payload.items ?? state.profit_by_sales,
        total_profit_by_sales: action.payload.total ?? state.total_profit_by_sales
      }
    }

    default: {
      return state
    }
  }
}

export default profitReportReducer
